import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { LoadingFooterProps } from '../../../models';
import { LoadingItemDesktop } from '../LoadingItem/desktop';
import { LoadingItemMobile } from '../LoadingItem/mobile';
import { LoadingItemTablet } from '../LoadingItem/tablet';

export const ResponsiveLoadingFooter: React.FC<LoadingFooterProps> = ({
  isLoading,
  isLoadingMore,
}) => {
  const responsiveLoadingComponent = useBreakpointValue({
    base: <LoadingItemMobile />,
    sm: <LoadingItemTablet />,
    lg: <LoadingItemDesktop />,
  });

  return <Box>{!isLoading && isLoadingMore && responsiveLoadingComponent}</Box>;
};
